document.addEventListener('DOMContentLoaded', () => {

	const toggles = document.querySelectorAll(
		'.wens-dark-mode-toggle .toggle'
	);

	if (!toggles.length) {
		return;
	}


	toggles.forEach((toggle) => {

		const sunIcon = toggle.querySelector('.sun-icon');
		const moonIcon = toggle.querySelector('.moon-icon');


		updateIcon();


		toggle.addEventListener('click', () => {

			const isDark = document.body.classList.toggle('dark-mode');


			document.cookie =
				'wens_dark_mode=' +
				(isDark ? 'dark' : 'light') +
				'; path=/; max-age=' +
				60 * 60 * 24 * 365;


			updateIcon();

		});


		function updateIcon() {

			if (document.body.classList.contains('dark-mode')) {

				sunIcon.style.display = 'flex';
				moonIcon.style.display = 'none';

			} else {

				sunIcon.style.display = 'none';
				moonIcon.style.display = 'flex';

			}

		}

	});

});